import { useEffect, useState, useRef } from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import useImageWrapper from "helpers/hooks/useImageWrapper";
import Photo from "components/shared/stays/Photo";
import styles from "components/shared/stays/SlideshowMedia.module.scss";

export default function SlideshowMedia({ slide }) {
  const { getImageWidth } = useImageWrapper();
  const [imgWidths, setImgWidths] = useState([0]);
  const imgWrapperRef = useRef(null);

  useEffect(() => {
    const calculatedWidth = getImageWidth([imgWrapperRef]);
    setImgWidths(calculatedWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.component}>
      <div
        className={styles.wrapper}
        style={{ maxWidth: `${slide.file.width}px` }}
      >
        <div
          className={cn(styles.sizer, {
            [styles.vertical]: slide.file.height > slide.file.width,
          })}
          style={{
            aspectRatio: `${slide.file.width} / ${slide.file.height}`,
            maxWidth: `${slide.file.width}px`,
            maxHeight: `${slide.file.height}px`,
          }}
          ref={imgWrapperRef}
        />
        <Photo
          src={slide.file.url}
          alt="Surf"
          layout="fill"
          objectFit="contain"
          containerWidth={imgWidths[0]}
        />
      </div>
    </div>
  );
}

SlideshowMedia.propTypes = {
  slide: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    position: PropTypes.number,
    created_at: PropTypes.string,
    file: PropTypes.shape({
      url: PropTypes.string,
      content_type: PropTypes.string,
      byte_size: PropTypes.number,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
  }).isRequired,
};
